import { render, staticRenderFns } from "./ContainerFrame.vue?vue&type=template&id=20dc5dd8&scoped=true&lang=pug&"
import script from "./ContainerFrame.vue?vue&type=script&lang=js&"
export * from "./ContainerFrame.vue?vue&type=script&lang=js&"
import style0 from "./ContainerFrame.vue?vue&type=style&index=0&id=20dc5dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc5dd8",
  null
  
)

export default component.exports